import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import DataGrid, { Column, DataGridTypes, Editing } from 'devextreme-react/data-grid';
import { CardAnalytics } from '../../library/card-analytics/CardAnalytics';
import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';
import './RevenueAnalysisCard.scss';
import { useAuth } from '../../../contexts/auth';
import { patchReport } from '../../../api/reports';
import notify from 'devextreme/ui/notify';

const toOidString = (value: unknown): string => {
    if (value && typeof value === 'object' && '_value' in value) {
        return String((value as { _value: unknown })._value);
    }
    return String(value);
};

export const RemarksCard = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const dataSource = new DataSource({
        store: {
            type: 'odata',
            version: 4,
            key: 'Oid',
            keyType: 'Guid',
            url: `${process.env.REACT_APP_URL}/api/odata/Report`,
            beforeSend: (e) => {
                e.headers = {
                    'Authorization': `Bearer ${user?.token}`
                };
            },
        },
        paginate: false,
        select: [
            'Oid',
            'Contract',
            'MoreWorkNeeded',
            'MaintenanceDate',
            'QuotationSent',
            'Remark',
            'RemarkDone'
        ],
        filter: [['MoreWorkNeeded', '=', false], 'and', ['RemarkDone', '=', false], 'and', ['Remark', '<>', '']],
        sort: ['MaintenanceDate'],
        expand: ['Contract(expand=Relation)']
    });

    const navigateToDetails = useCallback(({ data }: DataGridTypes.RowClickEvent) => {
        navigate('/crm-contact-details', { state: { relationOid: data.Contract.Relation.Oid._value.toString(), backTo: 'dashboard' } });
    }, []);

    const onRowUpdating = useCallback((e: DataGridTypes.RowUpdatingEvent) => {
        e.cancel = true;
        const oid = toOidString(e.key);
        const { RemarkDone } = e.newData as { RemarkDone?: boolean };

        void (async() => {
            try {
                await patchReport(oid, { RemarkDone }, user?.token);
                e.component.refresh();
            } catch {
                notify('Fout bij bijwerken van rapport', 'error', 2000);
            }
        })();
    }, [user?.token]);

    return (
        <CardAnalytics title='Opmerkingen' contentClass='sales-by-state grid'>
        <DataGrid
            dataSource={dataSource}
            height={290}
            hoverStateEnabled
            onRowUpdating={onRowUpdating}
            onRowClick={navigateToDetails}>
            <Editing
                mode='cell'
                allowUpdating
                allowAdding={false}
                allowDeleting={false} />
            <Column dataField='MaintenanceDate' width={100} allowEditing={false} dataType='date' format='dd-MM-yyyy' caption='Datum' />
            <Column caption='Relatie' allowEditing={false} dataField='Contract.Relation.Name' />
            <Column caption='Contract' allowEditing={false} dataField='Contract.ContractType' />
            <Column caption='Opmerking' allowEditing={false} dataField='Remark' />
            <Column caption='Gezien' dataField='RemarkDone' sortOrder='asc' />
            </DataGrid>
        </CardAnalytics>
    );
};
